import { Translate } from 'react-redux-i18n'
import LogsModal from './logs-modal'
import Guard from 'components/guard'
import Dashboard from 'endpoints/dashboard'
import ConfirmationModal from './confirmation-modal'

export default class extends React.Component {
  constructor() {
    super();
    this.state = { showLogs: false, showConfirmModal: false };
    this.showLogs = this.showLogs.bind(this);
    this.closeLogs = this.closeLogs.bind(this);
    this.runDBCheck = this.runDBCheck.bind(this);
    this.showConfirmationPopup = this.showConfirmationPopup.bind(this)
    this.closeConfirmationPopup = this.closeConfirmationPopup.bind(this)
  }

  showLogs() {
    this.setState({ showLogs: true });
  }

  closeLogs() {
    this.setState({ showLogs: false });
  }

  runDBCheck() {
    Dashboard.runDBCheck();
  }

  showConfirmationPopup() {
    this.setState({ showConfirmModal: true });
  }

  closeConfirmationPopup() {
    this.setState({ showConfirmModal: false });
  }

  render() {
    let { showLogs, showConfirmModal } = this.state;
    let status = this.props.status;
    if(status === null) return null;

    let btns = [];
    if(status === 'GENERATED') {
      btns.push(
        <button key="check" type="button" className="btn btn-secondary mr-2" disabled>
          <Translate value="home.draft_status_bar.db_check" />
        </button>
      );
      btns.push(
        <Guard key="release" permission="DB_RELEASE" level="exec">
          <button type="button" className="btn btn-secondary" onClick={this.showConfirmationPopup}>
            <Translate value="home.draft_status_bar.db_release" />
          </button>
        </Guard>
      );
    } else if(status === 'READY' || status === 'FAILED') {
      btns.push(
        <button key="check" type="button" className="btn btn-primary" onClick={this.runDBCheck}>
          <Translate value="home.draft_status_bar.db_check" />
        </button>
      );
    } else {
      btns.push(
        <button key="check" type="button" className="btn btn-primary" disabled>
          <Translate value="home.draft_status_bar.db_check" />
        </button>
      );
    }

    return (
      <div className="card card-default">
        <div className="card-body">
          <p className="lead">
            <label className="colon mr-1"><Translate value="home.draft_status_bar.data_state" /></label>
            <label className={`draft-status draft-status--${status.toLowerCase()}`}>
              <Translate value={`enums.draft_status.${status.toLowerCase()}`} />
            </label>
          </p>
        </div>
        <div className="card-footer text-right">
          <button type="button" className="btn btn-secondary mr-2" onClick={this.showLogs}>
            <Translate value="home.draft_status_bar.logs" />
          </button>
          {btns}
        </div>
        {showLogs ? <LogsModal onClose={this.closeLogs} /> : null}
        {showConfirmModal ? <ConfirmationModal onClose={this.closeConfirmationPopup} /> : null}
      </div>
    );
  }
}
